import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import { getItemFromStore } from "helpers/utils";

const AdvanceTable = ({ getTableProps, headers, page, prepareRow, headerClassName, bodyClassName, rowClassName, tableProps }) => {
	return (
		<div className="table-responsive scrollbar">
			<Table {...getTableProps(tableProps)}>
				<thead className={headerClassName}>
					<tr>
						{headers.map((column, index) => (
							<th key={index} {...column.getHeaderProps(column.getSortByToggleProps(column.headerProps))}>
								{column.render("Header")}
								{column.canSort ? column.isSorted ? column.isSortedDesc ? <span className="sort desc" /> : <span className="sort asc" /> : <span className="sort" /> : ""}
							</th>
						))}
					</tr>
				</thead>
				<tbody className={bodyClassName}>
					{page.map((row, i) => {
						const isRTL = getItemFromStore("isRTL",false)
						prepareRow(row);
						var styleString="";
						if (isRTL)
						{
							styleString = row.original?.workflowStatus?.css_ar;
						}
						else{
							styleString = row.original?.workflowStatus?.css;
						}
						//const rowStyle = styleString? styleString.split(/;(?![^(]*\))/).map(s => s.trim()).filter(Boolean) : undefined;
						const rowStyle = styleString
						? Object.fromEntries(
							styleString
								.split(/;(?![^(]*\))/) // split safely ignoring url(...)
								.map(s => s.trim())
								.filter(Boolean)
								.map(rule => {
								const [property, value] = rule.split(/:(.+)/); // split at first colon only
								const camelProp = property.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase());
								return [camelProp, value.trim()];
								})
							)
						: undefined;
						/* ? styleString.split(";").reduce((acc, pair) => {
							const [key, value] = pair.split(":").map(s => s.trim());
							if (key && value) {
								const camelKey = key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
								acc[camelKey] = value;
							}
							return acc;
							}, {})
						: undefined; */
						return (
							<tr key={i} className={rowClassName} {...row.getRowProps()}>
								{row.cells.map((cell, index) => {
									const cellStyle = cell.column.id === "generatedEmanifestID"? rowStyle : { fontWeight: rowStyle?.fontWeight };
									//const cellStyle = cell.column.id === "generatedEmanifestID" ? rowStyle : undefined;
									//const allCellStyle = rowStyle?rowStyle.fontWeight: undefined;
									return (
										<td key={index} {...cell.getCellProps(cell.column.cellProps)} style={cellStyle}>
											{cell.render("Cell")}
										</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</Table>
		</div>
	);
};
AdvanceTable.propTypes = {
	getTableProps: PropTypes.func,
	headers: PropTypes.array,
	page: PropTypes.array,
	prepareRow: PropTypes.func,
	headerClassName: PropTypes.string,
	bodyClassName: PropTypes.string,
	rowClassName: PropTypes.string,
	tableProps: PropTypes.object,
};

export default AdvanceTable;
